import axios from "axios";
import { server, userInterface } from "../../app/consts";

export const login = async (user: { 'username': string, 'password': string }) => {
    try {
        const res = await axios.post(server + 'login', { "username": user.username, "password": user.password })
        return res.data;
    }
    catch (error: unknown) {
        return Promise.reject(error)
    }
}

export const addUser = async (data: userInterface) => {
    try {
        const res = await axios.post(server + 'addUser', data, { headers: { Authorization: `Bearer ${sessionStorage.getItem('loginToken')}` } })
        return res.data;
    }
    catch (error: any) {
        console.error("Add User Failed\n", error)
        return Promise.reject(error)
    }
}

export const getAllUsers = async () => {
    try {
        const res = await axios.get(server + 'getAllUsers', { headers: { Authorization: `Bearer ${sessionStorage.getItem('loginToken')}` } })
        return res.data;
    }
    catch (error: any) {
        console.error("get Users Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserActiveStatus = async (username: string) => {
    try {
        const res = await axios.patch(server + 'updateUserActiveStatus', { "username": username }, { headers: { Authorization: `Bearer ${sessionStorage.getItem('loginToken')}` } })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserPhoneNum = async (data: { username: string, phone_num: string }) => {
    try {
        const res = await axios.patch(server + 'updateUserPhoneNum', { "username": data.username, "phone_num": data.phone_num }, { headers: { Authorization: `Bearer ${sessionStorage.getItem('loginToken')}` } })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserMfaStatus = async (username: string) => {
    try {
        const res = await axios.patch(server + 'updateMfaStatus', { "username": username }, { headers: { Authorization: `Bearer ${sessionStorage.getItem('loginToken')}` } })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}